import { get, isEmpty } from 'lodash';

function checkPostalFieldValues(values) {
  return !isEmpty(get(values, 'address_type')) && isEmpty(get(values, 'postal_code'));
}

export default checkPostalFieldValues;
